module.exports = __webpack_public_path__ + "static/media/MR.71d634fe.png";